/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import ReactGA from 'react-ga4';
import MenuIconOneDot from '../Icons/MenuIconOneDot';
import MenuIconThreeDots from '../Icons/MenuIconThreeDot';

import ArrowDown from '../Icons/ArrowDown';
import Interpreter from '../Icons/Interpreter';
import Facebook from '../Icons/Facebook';
import Instagram from '../Icons/Instagram';
import LinkedIn from '../Icons/LinkedIn';
import YouTube from '../Icons/YouTube';
import Twitter from '../Icons/Twitter';

// Content
import Introduction from './Content/Introduction';
import MenuProjects from './Content/MenuProjects';

// import imgBgFooter from 'assets/images/blue-waves.svg';
import imgInterpreterService from 'assets/images/interpreter-translation-image.svg';

import './LeftSidebar.scss';

type Props = {
  activeMenu: string;
  setActiveMenu: (menu: string) => void;
  projectSelected: any;
  setProjectSelected: (project: string) => void;
};

type TypeMenuItem = {
  title: string;
  value: string;
  menuIcon: JSX.Element;
  content: JSX.Element;
};

const LeftSidebar = ({
  activeMenu,
  setActiveMenu,
  projectSelected,
  setProjectSelected,
}: Props) => {
  const menuItems: TypeMenuItem[] = [
    {
      title: 'About South East Water',
      value: 'about',
      menuIcon: <MenuIconOneDot />,
      content: <Introduction />,
    },
    {
      title: 'Major projects',
      value: 'major-projects',
      menuIcon: <MenuIconThreeDots />,
      content: (
        <MenuProjects
          projectSelected={projectSelected}
          setProjectSelected={(project) => setProjectSelected(project)}
          category="major-projects"
          content={
            <>
              <div className="content-wrapper">
                <p>
                  Over the next few years you’ll see our crews a lot as we’re
                  continually maintaining, upgrading and renewing our pipes and
                  pumps that keep the water and sewerage networks flowing.
                </p>
                <p>
                  This map shows some of the renewals and major projects we have
                  coming up over the next few years. General maintenance and
                  operational network interruptions can be viewed&nbsp;
                  <a
                    target="_blank"
                    href="https://mysupport.southeastwater.com.au/LIVE?utm_-source=home&utm_medium=website&utm_campaign=sew-live-banner"
                    rel="noreferrer"
                  >
                    here
                  </a>
                  .
                </p>
                <p>
                  Water and sewerage services will not be impacted during these
                  projects. We'll notify you in advance of any project occurring
                  in your area.
                </p>
              </div>
              <div className="content-wrapper light-blue">
                <p>
                  <span className="bold">Major projects</span>&nbsp;These
                  projects tend to move slowly along alignments and are lengthy
                  in duration, with some projects lasting over two years.
                </p>
                <p>
                  Major projects appear in orange and purple, depending on the
                  type of project it is.
                </p>
              </div>
            </>
          }
        />
      ),
    },
    {
      title: 'Water main renewals',
      value: 'water-renewals',
      menuIcon: <MenuIconThreeDots />,
      content: (
        <MenuProjects
          projectSelected={projectSelected}
          setProjectSelected={(project) => setProjectSelected(project)}
          category="water-renewals"
          content={
            <>
              <div className="content-wrapper">
                <p>
                  Over the next few years you’ll see our crews a lot as we’re
                  continually maintaining, upgrading and renewing our pipes and
                  pumps that keep the water and sewerage networks flowing.
                </p>
                <p>
                  This map shows some of the renewals and major projects we have
                  coming up over the next few years. General maintenance and
                  operational network interruptions can be viewed&nbsp;
                  <a
                    target="_blank"
                    href="https://mysupport.southeastwater.com.au/LIVE?utm_-source=home&utm_medium=website&utm_campaign=sew-live-banner"
                    rel="noreferrer"
                  >
                    here
                  </a>
                  .
                </p>
                <p>
                  Water and sewerage services will not be impacted during these
                  projects. We'll notify you in advance of any project occurring
                  in your area.
                </p>
              </div>
              <div className="content-wrapper light-blue">
                <p>
                  <span className="bold">Water main renewals</span>: These
                  projects are fast moving along the alignment and are usually
                  of short duration (up to three months). On occasion some
                  renewals will take longer, due to the length of asset being
                  renewed and the complexities of the area. On the map renewals
                  appear in blue.
                </p>
              </div>
            </>
          }
        />
      ),
    },
  ];

  const isMenuActive = (menu: TypeMenuItem) => activeMenu === menu.value;
  return (
    <aside className="left-sidebar">
      <ul className="menu-items">
        {menuItems.map((menu) => (
          <li
            key={menu.value}
            className={`menu-item ${
              isMenuActive(menu) ? 'active' : 'not-active'
            }`}
          >
            <a
              href="#"
              rel="nofollow"
              onClick={(e) => {
                e.preventDefault();
                if (isMenuActive(menu)) {
                  setActiveMenu('');
                  ReactGA.event({
                    category: 'Left Menu',
                    action: 'Collapse',
                    label: menu.title,
                  });
                  return;
                }
                setActiveMenu(menu.value);
                ReactGA.event({
                  category: 'Left Menu',
                  action: 'Expand',
                  label: menu.title,
                });
              }}
            >
              <div className="title">
                {menu.menuIcon}
                <h2>{menu.title}</h2>
              </div>
              <ArrowDown />
            </a>
            <div className="content-wrapper">{menu.content}</div>
          </li>
        ))}
      </ul>

      <div className="footer">
        {/* <img className="blue-waves" src={imgBgFooter} alt="" /> */}
        <button className="btn-contact">
          <span>CONTACT</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            viewBox="0 0 22.38 18.22"
            className="arrow"
          >
            <defs></defs>
            <g id="Spare_to_ignore" data-name="Spare to ignore">
              <g style={{ opacity: 0.5 }}>
                <polyline
                  style={{
                    fill: 'none',
                    stroke: '#fff',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeWidth: '2px',
                  }}
                  points="13.45 2.24 20.3 9.09 13.06 16.32"
                />
                <line
                  style={{
                    fill: 'none',
                    stroke: '#fff',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeWidth: '2px',
                  }}
                  x1="3.13"
                  y1="9.14"
                  x2="19.27"
                  y2="9.14"
                />
              </g>
            </g>
          </svg>
          <svg
            className="curve"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 74.04 38.81"
          >
            <path
              style={{ fill: '#0075e3' }}
              d="m62.58,34.21H8.93V5.63h2.07c36.46,0,36.35,27.1,51.58,28.58Z"
            />
          </svg>
        </button>
        <div className="content">
          <div className="info">
            <p>For further information about this project:</p>
            <p>
              Email:{' '}
              <a
                href="mailto:engagement@sew.com.au"
                rel="noreferrer"
                onClick={() => {
                  ReactGA.event({
                    category: `Left Menu - Contact`,
                    action: 'Email link',
                    label: 'mailto: engagement@sew.com.au',
                  });
                }}
              >
                engagement@sew.com.au
              </a>
            </p>
          </div>
          <div className="additional-info">
            <div
              className="interpreter"
              onMouseEnter={() => {
                ReactGA.event({
                  category: `Left Menu - Contact`,
                  action: 'Hover-over',
                  label: 'Interpreter Services',
                });
              }}
            >
              <Interpreter />
              Interpreter Service&nbsp;
              <a className="bold" href="tel:0392800779">
                03 9280 0779
              </a>
              <img
                src={imgInterpreterService}
                className="interpreter-translation-banner"
                alt="Interpreter Service Translation"
                title="Interpreter Service Translation"
              />
            </div>
            <ul className="social-media-icons">
              <li>
                <a
                  href="https://www.facebook.com/SEWmelbourne"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => {
                    ReactGA.event({
                      category: `Left Menu - Contact`,
                      action: '<a href> link',
                      label: 'Facebook',
                    });
                  }}
                >
                  <Facebook />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/southeastwateraustralia/"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => {
                    ReactGA.event({
                      category: `Left Menu - Contact`,
                      action: '<a href> link',
                      label: 'Instagram',
                    });
                  }}
                >
                  <Instagram />
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/south-east-water/"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => {
                    ReactGA.event({
                      category: `Left Menu - Contact`,
                      action: '<a href> link',
                      label: 'Linkedin',
                    });
                  }}
                >
                  <LinkedIn />
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/user/southeastwater"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => {
                    ReactGA.event({
                      category: `Left Menu - Contact`,
                      action: '<a href> link',
                      label: 'Youtube',
                    });
                  }}
                >
                  <YouTube />
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/southeastwater"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => {
                    ReactGA.event({
                      category: `Left Menu - Contact`,
                      action: '<a href> link',
                      label: 'Twitter',
                    });
                  }}
                >
                  <Twitter />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default LeftSidebar;
